module.exports = __webpack_public_path__ + "static/media/CI.f9fe18b5.png";